module.exports = __webpack_public_path__ + "img/chart.ed64f23.png";